import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, Spin, Select, Popover, Space } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import './wpaApplRecordReport.css'
import SelectCohortModule from './selectCohortModule';
import CohortProgSearchModal from './cohortProgSearchModal'

const { Option } = Select;

const WpaApplRecordReport = () => {

    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [isSearchModuleModal, setIsSearchModuleModal] = useState(false);
    const [isSearchCohortProgModal, setIsSearchCohortProgModal] = useState(false);
    const [cohortList, setCohortList] = useState([]);

    const tableColumns = {
        wpaApplId: "wpa_appl_id",
        firstName: "first_name",
        studentAcctId: "student_acct_id",
        companyName: "company_name",
        industrySupervisorName: "industry_supervisor_name",
        wilHours: "wil_hours",
        mark: "mark",
        applyDate: "apply_date",
        lastUpdatedDate: "last_updte_dte",
        sentToIs: "sent_to_is",
        wpaStatus: "wpa_status",
    }

    useEffect(() => {
        searchCohortList();
        search(pageSize, 1, "N", false);
    }, []);

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortModule/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
                // let newModel = { cohortId: Config?.cohort?.cohortId };
                // setSearchModel(newModel);
                // form2.setFieldsValue(newModel)
                // search(pageSize, 1, "N", false, newModel)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("wpaAppl/searchReport", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        form2.resetFields();
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "WPA Record Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "wpaAppl/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }
    
    const selectCohortModuleClose = (flag, model) => {
        if (flag) {
            setSearchModel(model1 => {
                return { ...model1, ...model };
            });
        }
        setIsSearchModuleModal(false);
    }

    const closeSearchCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model1 => {
                return { ...model1, ...cohortProg };
            });
        }
        setIsSearchCohortProgModal(false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            width: '1%',
        },
        {
            title: 'Module Cohort',
            dataIndex: 'cohortYear',
            width: '1.5%',
        },
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            width: '1.5%',
        },
        {
            title: 'Student Name',
            dataIndex: 'firstName',
            width: '2%',
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            width: '1%',
            render: (text) => Base.numberReplaceSymbol(Base.parseToFixed(text, 1), "N/A"),
        },
        {
            title: 'Submit Date',
            dataIndex: 'applyDate',
            width: '1.5%',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: "Assigned-AS",
            dataIndex: 'academicSupervisorUserName',
            width: '2%',
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            width: '2%',
            render: text => ContextHandler.getMapValue('wpaFormStatusMap', text),
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            width: '2%',
        },
        {
            title: "Module Code",
            dataIndex: 'moduleCode',
            width: '1.6%',
        },
        {
            title: "Module Name",
            dataIndex: 'moduleName',
            width: '2%',
        },
        {
            title: "Total WIL Hours",
            dataIndex: 'wilHours',
            width: '1.7%',
        },
        {
            title: "WIL Period Start",
            dataIndex: 'periodStartDate',
            width: '1.7%',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: "WIL Period End",
            dataIndex: 'periodEndDate',
            width: '1.5%',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Company/ Organisation Name',
            dataIndex: 'companyName',
            width: '3%',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Company/ Organisation Address',
            dataIndex: 'companyAddress',
            width: '3%',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Name of Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            width: '3%',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Position',
            dataIndex: 'industrySupervisorPosition',
            width: '2%',
        },
        {
            title: 'Telephone Number',
            dataIndex: 'industrySupervisorPhone',
            width: '2%',
        },
        {
            title: 'Email Address',
            dataIndex: 'industrySupervisorEmail',
            width: '2%',
        },
        {
            title: 'Name of Signature',
            dataIndex: 'signature',
            width: '2%',
        },
        {
            title: 'Date',
            dataIndex: 'signatureDate',
            width: '1.5%',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: "Section A",
            children: [
                {
                    title: 'Activity 1',
                    dataIndex: 'activity1',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Activity 1 %',
                    dataIndex: 'activityProportion1',
                    width: '2%',
                    render: text => text && text + '%'
                },
                {
                    title: 'Activity 2',
                    dataIndex: 'activity2',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Activity 2 %',
                    dataIndex: 'activityProportion2',
                    width: '2%',
                    render: text => text && text + '%'
                },
                {
                    title: 'Activity 3',
                    dataIndex: 'activity3',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Activity 3 %',
                    dataIndex: 'activityProportion3',
                    width: '2%',
                    render: text => text && text + '%'
                },
            ]
        },
        {
            title: "Section B",
            children: [
                {
                    title: 'Q1',
                    dataIndex: 'wpaQuestion1',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q1 Result',
                    dataIndex: 'wpaQuestionResult1',
                    width: '1.2%',
                },
                {
                    title: 'Q2',
                    dataIndex: 'wpaQuestion2',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q2 Result',
                    dataIndex: 'wpaQuestionResult2',
                    width: '1.2%',
                },
                {
                    title: 'Q3',
                    dataIndex: 'wpaQuestion3',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q3 Result',
                    dataIndex: 'wpaQuestionResult3',
                    width: '1.2%',
                },
                {
                    title: 'Q4',
                    dataIndex: 'wpaQuestion4',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q4 Result',
                    dataIndex: 'wpaQuestionResult4',
                    width: '1.2%',
                },
                {
                    title: 'Q5',
                    dataIndex: 'wpaQuestion5',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q5 Result',
                    dataIndex: 'wpaQuestionResult5',
                    width: '1.2%',
                },
                {
                    title: 'Q6',
                    dataIndex: 'wpaQuestion6',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q6 Result',
                    dataIndex: 'wpaQuestionResult6',
                    width: '1.2%',
                },
                {
                    title: 'Q7',
                    dataIndex: 'wpaQuestion7',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q7 Result',
                    dataIndex: 'wpaQuestionResult7',
                    width: '1.2%',
                },
                {
                    title: 'Q8',
                    dataIndex: 'wpaQuestion8',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q8 Result',
                    dataIndex: 'wpaQuestionResult8',
                    width: '1.2%',
                },
                {
                    title: 'Q9',
                    dataIndex: 'programmeSpecificWpaQuestion9',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q9 Result',
                    dataIndex: 'wpaQuestionResult9',
                    width: '1.2%',
                },
                {
                    title: 'Q10',
                    dataIndex: 'programmeSpecificWpaQuestion10',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q10 Result',
                    dataIndex: 'wpaQuestionResult10',
                    width: '1.2%',
                },
                {
                    title: 'Q11',
                    dataIndex: 'programmeSpecificWpaQuestion11',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q11 Result',
                    dataIndex: 'wpaQuestionResult11',
                    width: '1.2%',
                },
                {
                    title: 'Q12',
                    dataIndex: 'programmeSpecificWpaQuestion12',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q12 Result',
                    dataIndex: 'wpaQuestionResult12',
                    width: '1.2%',
                },
                {
                    title: 'Q13',
                    dataIndex: 'programmeSpecificWpaQuestion13',
                    width: '1.8%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q13 Result',
                    dataIndex: 'wpaQuestionResult13',
                    width: '1.2%',
                },
            ],
        },
        {
            title: "Section C",
            children: [
                {
                    title: 'Work Performance',
                    dataIndex: 'workPerformance',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Areas of Strength',
                    dataIndex: 'strengthArea',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Areas of Growth',
                    dataIndex: 'growthArea',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Comments',
                    dataIndex: 'workPerformanceComment',
                    width: '1.5%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
            ],
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template wpaApplRecordReport">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    <Form form={form2} onFinish={onSearch}>
                        <div className='sysSearchRow sysSearchBox'>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.studentAcctId[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.studentAcctId || ''}
                                            placeholder={trans.studentAcctId[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // 只允许输入字母和数字
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.firstName || ''}
                                            placeholder={trans.studentName[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('firstName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.wpaStatus[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select className="sysSelect" placeholder={trans.wpaStatus[Config.backLang]}
                                            value={searchModel.wpaStatus || ''}
                                            onChange={(e) => searchChange('wpaStatus', e)}
                                        >
                                            <Option value=""></Option>
                                            {context.wpaFormStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme </div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.progCode || ''} disabled
                                            placeholder="Programme "
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchCohortProgModal(true) }}>Select</Button>
                                    {searchModel.progTitle && <div style={{ marginLeft: '10px' }}>{searchModel.progTitle}</div>}
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Module</div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.moduleCode || ''} disabled
                                            placeholder="Module"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsSearchModuleModal(true) }}>Select</Button>
                                    {searchModel.moduleName && <div style={{ marginLeft: '10px' }}>{searchModel.moduleName}</div>}
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle ">Module Cohort</div>
                                    <div className="sysSerchInput">
                                        <Select className="sysSelect" placeholder="Module Cohort"
                                            value={searchModel.cohortId || ''}
                                            onChange={(e) => searchChange('cohortId', e)}
                                        >
                                            <Option value=''></Option>
                                            {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                            <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 8500 }}
                            rowKey="wpaApplId"
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>
                </Spin>
            </div>
            {isSearchModuleModal && <SelectCohortModule onClose={selectCohortModuleClose} />}
            {isSearchCohortProgModal && <CohortProgSearchModal onClose={closeSearchCohortProgModal} />}
        </div>
    )
}

export default WpaApplRecordReport;